import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule as NgXTranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { MenusModule } from '@progress/kendo-angular-menu';
import { TranslateModule } from '@shared/translate';
import {
  AppLoaderComponent,
  NotificationPopupComponent,
  PopupBodyComponent,
  PopupLayoutComponent,
} from './components';
import { ShowErrorAfterBlurDirective } from './directives';
import { NotificationService } from './services';

const COMPONENTS_AND_DIRECTIVES = [
  AppLoaderComponent,
  NotificationPopupComponent,
  PopupBodyComponent,
  PopupLayoutComponent,
  ShowErrorAfterBlurDirective
];
const SERVICES = [NotificationService];
const SHARED_IMPORTS = [CommonModule, FontAwesomeModule, NgXTranslateModule, TranslateModule];

@NgModule({
  imports: [...SHARED_IMPORTS, FormsModule, LoaderModule, MenusModule],
  declarations: [...COMPONENTS_AND_DIRECTIVES],
  providers: [...SERVICES],
  exports: [...COMPONENTS_AND_DIRECTIVES, ...SHARED_IMPORTS],
})
export class SharedUIModule {}
